( function( $, document, window ) {
	'use strict';

	// Slick Slideshow
	var columnsText = document.querySelectorAll( '.column-section.-format_text .wrapper' ),
		slickifyText;

	if ( columnsText.length <= 0 ) {
		return;
	}

	slickifyText = function( el, breakpointSettings ) {
		$( el ).slick( {
			autoplay: false,
			speed: 500,
			arrows: false,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			prevArrow: '',
			nextArrow: '',
			responsive: [
				{
					breakpoint: 767,
					settings: breakpointSettings
				}
			]
		} );
	};

	$( document ).ready( function() {

		var breakpointSettings = 'unslick';

		Array.from( columnsText ).forEach( function( el ) {

			// Add Slick settings above 767 if there's enough slides.
			if ( el.children.length > 2 ) {
				breakpointSettings = {
					arrows: true,
					dots: false,
					slidesToShow: 2,
					prevArrow: '<button type="button" class="slick-prev">Previous</button>',
					nextArrow: '<button type="button" class="slick-next">Next</button>'
				};
			}

			// Run Slick
			slickifyText( el, breakpointSettings );
		} );
	} );

} )( jQuery, document, window );
